function mailchimp($form, success = false) {
  $($form).on("submit", function(e) {
    e.preventDefault();
    const $this = $(this);
    const serialize = $this.serialize();
    const action = $this.attr("action").replace("post?u=", "post-json?u=");
    const $errorHolder = $this.find('[id$="mce-error-response"]');
    const $successHolder = $this.find('[id$="mce-success-response"]');

    if (!$this.find(".checkbox-input").is(":checked") && $this.find(".checkbox-input").length) {
      $this.find(".response:eq(0)").empty().text("Please agree to the Terms and Conditions.").show();
      return;
    }

    $.ajax({
      url: action,
      type: $this.attr("method"),
      dataType: "jsonp",
      jsonp: "c",
      data: serialize
    }).done(function(data) {
      if (data.result === "error") {
        $errorHolder.show().html(data.msg.replace(/^\d\s-\s/g, ""));
      } else if (data.result === "success") {
          console.log(1);
        if (success) {
          success();
        } else {
          $errorHolder.hide().empty();
          $successHolder.show().html(data.msg);
        }
      }
    });
  });
}

module.exports = {
  mailchimp
};



// WEBPACK FOOTER //
// ../assets/js/mailchimp.js